<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Servicios aprobados">
          <div class="table-responsive rqTable">
            <div class="form-group form-inline pull-left">
              <select v-model="numPages" class="form-control">
                <option v-for="(num,k) in [10, 30, 50, 100]" :key="k" :value="num">{{ num }}</option>
              </select> &nbsp;
              <input
                v-model="search"
                type="search"
                class="form-control"
                placeholder="Buscar"
              />
            </div>
            <div class="form-group form-inline pull-right">
              <date-picker
                v-model="date_start"
                lang="es"
                placeholder="Desde"
                type="date"
                required
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <date-picker
                v-model="date_end"
                lang="es"
                placeholder="Hasta"
                type="date"
                required
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <button class="btn btn-primary" @click="searchByDate()">Buscar</button>&nbsp;
              <download-excel
                class="btn btn-primary"
                :data="filteredRequeriments"
                :fields="json_fields"
                name="RequerimientosAprobados.xls"
              >Descargar Excel</download-excel>
            </div>
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>BL/Booking</th>
                  <th>Contenedor</th>
                  <th>Fecha (cita)</th>
                  <th>Cliente</th>
                  <th>Facturar a</th>
                  <th>Solicitante</th>
                  <th>Línea naviera</th>
                  <th>Tipo de servicio</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="9">
                    <i class="center fa fa-lg fa-spinner fa-spin"></i>
                  </td>
                </tr>
                <tr
                  v-if="!loading"
                  v-for="(requeriment,k) in paginated('filteredRequeriments')"
                  :key="k"
                  @contextmenu.prevent="selectService(requeriment)"
                >
                  <td>{{requeriment.service.doc_number}}</td>
                  <td>{{requeriment.container_number}}</td>
                  <td>{{requeriment.date | formatDateTime}}</td>
                  <td>{{requeriment.service.company? requeriment.service.company.name : ''}}</td>
                  <td>{{requeriment.service.company? requeriment.service.company.company_bill.name : ''}}</td>
                  <td>{{requeriment.service.applicant ? `${requeriment.service.applicant.name} ${requeriment.service.applicant.last_name}` : ''}}</td>
                  <td>{{requeriment.service.shipping_line ? requeriment.service.shipping_line.name : ''}}</td>
                  <td>{{requeriment.service.service_type ? requeriment.service.service_type.name : ''}}</td>
                  <td>
                    <b-button
                      @click="editRequeriment(requeriment.id)"
                      type="button"
                      variant="primary"
                    >Editar</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <paginate
              name="filteredRequeriments"
              :list="filteredRequeriments"
              class="paginate-list"
              :per="numPages"
            ></paginate>
            <paginate-links
              for="filteredRequeriments"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<'
              }"
              :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
            ></paginate-links>
            <context-menu id="context-menu" ref="ctxMenu">
              <li @click="Detail()" class="ctx-item">Ver detalle</li>
            </context-menu>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";
import requeriments_approved from "@/helpers/json_fields/requeriments_approved";

export default {
  data() {
    return {
      requeriments: [],
      numPages: 100,
      constants: {},
      paginate: ["filteredRequeriments"],
      search: "",
      service: {},
      date_end: moment()
        .add(1, "days")
        .format("YYYY-MM-DD 23:59:59"),
      date_start: moment().format("YYYY-MM-DD 00:00:00"),
      loading: true,
      json_fields: requeriments_approved
    };
  },
  computed: {
    filteredRequeriments() {
      return this.requeriments.filter(requeriment => {
        let result = true;
        if (this.search) {
          result =
            requeriment.service.company.name
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            (requeriment.service.company.company_bill.name
              .toLowerCase()
              .includes(this.search.toLowerCase())) ||
            (requeriment.container_number &&
              requeriment.container_number
                .toLowerCase()
                .includes(this.search.toLowerCase())) ||
            requeriment.service.doc_number
              .toLowerCase()
              .includes(this.search.toLowerCase());
        }

        return result;
      });
    }
  },
  mounted() {
    this.constants = constants;
    this.searchByDate();
  },
  methods: {
    searchByDate() {
      if (
        moment(this.start_date).isValid() &&
        moment(this.end_date).isValid()
      ) {
        let data = {
          date_start: moment(this.date_start).format("YYYY-MM-DD 00:00:00"),
          date_end: moment(this.date_end).format("YYYY-MM-DD 23:59:59"),
          finish: false,
          approved: true,
          service_code: [constants.IMPORTACION, constants.EXPORTACION]
        };

        this.loading = true;
        api.post("/list_requeriments", data).then(response => {
          this.requeriments = response.requeriments;
          this.loading = false;
        });
      } else {
        this.$toastr.error(
          `Debes indicar ambas fechas.`,
          "Buscador por fecha",
          { positionClass: "toast-top-center", closeButton: true }
        );
      }
    },
    selectService(requeriment) {
      this.requeriment = requeriment;
      this.$refs.ctxMenu.open();
    },
    Detail() {
      // this.$router.push(`/services/detail/${this.service.id}`);
      this.$router.push(
        `/requeriments/${
          this.requeriment.service.service_type.code === constants.IMPORTACION
            ? "import"
            : "export"
        }/detail/${this.requeriment.id}`
      );
    },
    editRequeriment(id) {
      this.$router.push(`/requeriment/edit/${id}`);
    }
  }
};
</script>
